import React from 'react'
import { getNavigationMenuIcon } from './utils'

interface Props {
  name: string;
  size?: number;
  type?: App.Design.ContentColour
}

export function Icon(props: Props) {
  const { name, size = 48, type } = props
  const IconComponent = getNavigationMenuIcon(name)

  if (IconComponent) {
    return <IconComponent size={size} colour={type} />
  }

  return null
}

export default Icon
